import { ACTION_TYPES } from 'constants'

const initialState = {
  menuDrawer: false,
}

const MenuToggleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.MENU_TOGGLE: {
      return {
        ...state,
        menuDrawer: action.payload,
      }
    }
    default:
      return state
  }
}

export default MenuToggleReducer
